import { t } from '../../presentation/adapters/translate/translate'

export class NotFound extends Error {
  constructor (body:any) {
    super(t(body.message))
    this.name = body.message
  }
}
